<template>
    <b-navbar-nav>
      <b-nav-item-dropdown text="Admin" type="dark">
        <b-dropdown-item :to="{name: 'admin.competitions'}">Wettbewerbe</b-dropdown-item>
        <b-dropdown-item :to="{name: 'admin.users'}">Benutzer</b-dropdown-item>
        <b-dropdown-item :to="{name: 'admin.schools'}">Schulen</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
</template>

<script>
  export default {
    name: 'NavbarAdmin'
  }
</script>



// WEBPACK FOOTER //
// src/components/navbar/Admin.vue